module.exports = __webpack_public_path__ + "img/benjike8.684db974.png";